import React from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import './loading.scss';
export var LoadingDefault = function (props) {
    var t = useTranslation().t;
    return React.createElement("div", null, t('common.loading'));
};
export var LoadingWidget = function (props) {
    var t = useTranslation().t;
    var _a = props.size, size = _a === void 0 ? 40 : _a;
    return React.createElement("div", { className: "loading-widget-container" },
        React.createElement(CustomLoading, { size: size }),
        React.createElement("div", { className: "loading-widget-text" },
            React.createElement("span", null, t('common.loading'))));
};
export var CustomLoading = function (props) {
    var size = props.size;
    return (React.createElement("div", { className: "custom-loading-container" },
        React.createElement(CircularProgress, { variant: "determinate", className: "loading-bottom", size: size, thickness: 4, value: 120 }),
        React.createElement(CircularProgress, { variant: "indeterminate", disableShrink: true, className: "loading-top", classes: {
                circle: "loading-circle",
            }, size: size, thickness: 4 })));
};
export default CustomLoading;
